export interface IMenuItem {
    label: string,
    link: string,
    children?: IMenuItem[]
}

const menuNavbar: IMenuItem[] = [
    {
        label: "کابینت آشپزخانه",
        link: "https://salamsakhteman.com/blog/%d8%b9%da%a9%d8%b3-%da%a9%d8%a7%d8%a8%db%8c%d9%86%d8%aa",
        children: [
            {
                label: "نمونه کار کابینت",
                link: "/models"
            },
            {
                label: "قیمت کابینت",
                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA/",
                children: [
                    {
                        label: "قیمت انواع کابینت مدرن",
                        link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA/",
                        children: [
                            {
                                label: "قیمت کابینت ام دی اف",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D8%A7%D9%85-%D8%AF%DB%8C-%D8%A7%D9%81-mdf",
                            },
                            {
                                label: "قیمت کابینت های گلاس",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D9%87%D8%A7%DB%8C-%DA%AF%D9%84%D8%A7%D8%B3",
                            },
                            {
                                label: "قیمت کابینت فلزی",
                                link: "https://salamsakhteman.com/blog/%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D8%A2%D8%B4%D9%BE%D8%B2%D8%AE%D8%A7%D9%86%D9%87-%D9%81%D9%84%D8%B2%DB%8C"
                            },
                            {
                                label: "قیمت کابینت پی وی سی- PVC",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D9%BE%DB%8C-%D9%88%DB%8C-%D8%B3%DB%8C"
                            }
                        ]
                    },
                    {
                        label: "قیمت انواع کابینت کلاسیک",
                        link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%DA%A9%D9%84%D8%A7%D8%B3%DB%8C%DA%A9/",
                        children: [
                            {
                                label: "قیمت کابینت چوبی",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%DA%86%D9%88%D8%A8%DB%8C"
                            },
                            {
                                label: "قیمت کابینت روکش چوب",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D8%B1%D9%88%DA%A9%D8%B4-%DA%86%D9%88%D8%A8"
                            },
                            {
                                label: "قیمت کابینت ممبران یا وکیوم",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D9%85%D9%85%D8%A8%D8%B1%D8%A7%D9%86-%D9%88%DA%A9%DB%8C%D9%88%D9%85"
                            },
                            {
                                label: "قیمت کابینت پلی اورتان",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D9%BE%D9%84%DB%8C-%D8%A7%D9%88%D8%B1%D8%AA%D8%A7%D9%86"
                            },
                            {
                                label: "قیمت کابینت انزو (پولیشی)",
                                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D8%A7%D9%86%D8%B2%D9%88/"
                            },
                        ]
                    },
                    {
                        label: "قیمت انواع کابینت نئوکلاسیک",
                        link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D8%A7%D8%A8%DB%8C%D9%86%D8%AA-%D9%86%D8%A6%D9%88%DA%A9%D9%84%D8%A7%D8%B3%DB%8C%DA%A9"
                    }
                ]
            },
        ]
    },
    {
        label: "کمد دیواری",
        link: "https://salamsakhteman.com/blog/%D9%85%D8%AF%D9%84-%D9%87%D8%A7%DB%8C-%DA%A9%D9%85%D8%AF-%D8%AF%DB%8C%D9%88%D8%A7%D8%B1%DB%8C",
        children: [
            {
                label: "قیمت کمد دیواری",
                link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D9%85%D8%AF-%D8%AF%DB%8C%D9%88%D8%A7%D8%B1%DB%8C",
                children: [
                    {
                        label: "قیمت کمد دیواری ریلی",
                        link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D9%85%D8%AF-%D8%AF%DB%8C%D9%88%D8%A7%D8%B1%DB%8C-%D8%B1%DB%8C%D9%84%DB%8C"
                    },
                    {
                        label: "قیمت کمد دیواری ام دی اف",
                        link: "https://salamsakhteman.com/blog/%d9%82%db%8c%d9%85%d8%aa-%da%a9%d9%85%d8%af%d8%af%db%8c%d9%88%d8%a7%d8%b1%db%8c-mdf"
                    },
                    {
                        label: "قیمت کمد دیواری ممبران",
                        link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D9%85%D8%AF-%D9%85%D9%85%D8%A8%D8%B1%D8%A7%D9%86"
                    },
                    {
                        label: "قیمت کمد دیواری نئوکلاسیک",
                        link: "https://salamsakhteman.com/blog/%d9%82%db%8c%d9%85%d8%aa-%da%a9%d9%85%d8%af-%d8%af%db%8c%d9%88%d8%a7%d8%b1%db%8c-%d9%86%d8%a6%d9%88%da%a9%d9%84%d8%a7%d8%b3%db%8c%da%a9"
                    },
                    {
                        label: "قیمت کمد دیواری چوب و روکش چوب",
                        link: "https://salamsakhteman.com/blog/%D9%82%DB%8C%D9%85%D8%AA-%DA%A9%D9%85%D8%AF-%D8%AF%DB%8C%D9%88%D8%A7%D8%B1%DB%8C-%DA%86%D9%88%D8%A8%DB%8C"
                    }
                ]
            },
            {
                label: "نمونه کار کمد دیواری",
                link: "https://salamsakhteman.com/blog/%D9%85%D8%AF%D9%84-%D9%87%D8%A7%DB%8C-%DA%A9%D9%85%D8%AF-%D8%AF%DB%8C%D9%88%D8%A7%D8%B1%DB%8C"
            }
        ]
    },
    {
        label: "مشاهده کارگاه‌دارها",
        link: "/workshops"
    },
    {
        label: "مشاهده کابینت سازها",
        link: "/contractors",
        children: [
            {
                label: "کابینت ساز در تهران",
                link: "contractors/cities/tehran"
            },
            {
                label: "کابینت ساز در کرج",
                link: "/contractors/cities/karaj"
            },
            {
                label: "کابینت ساز در مشهد",
                link: "/contractors/cities/mashhad"
            },
            {
                label: "کابینت ساز در اصفهان",
                link: "/contractors/cities/isfahan"
            },
            {
                label: "کابینت ساز در شیراز",
                link: "/contractors/cities/shiraz"
            },
            {
                label: "کابینت ساز در رشت",
                link: "/contractors/cities/rasht"
            },
            {
                label: "کابینت ساز در اهواز",
                link: "/contractors/cities/ahvaz"
            },
            {
                label: "کابینت ساز در کرمان",
                link: "/contractors/cities/Kerman"
            },
            {
                label: "کابینت ساز در قم",
                link: "/contractors/cities/ghom"
            },
            {
                label: "کابینت ساز در ساری",
                link: "/contractors/cities/sari"
            }
        ]
    },
    {
        label: "مجله سایت",
        link: "https://salamsakhteman.com/blog"
    },
    {
        label: "درباره ما",
        link: "/about-us"
    },
]

export default menuNavbar